(() => {
  const initializeKlaviyoForms = (scope = document) => {
    scope.querySelectorAll('[data-about-klaviyo-form]').forEach((container) => {
      const companyId = container.dataset.klaviyoCompanyId;
      const formId = container.dataset.klaviyoFormId;
      if (!companyId || !formId) return;

      const customizeForm = () => {
        const email = container.querySelector('input[type="email"]');
        const button = container.querySelector('button.klaviyo-form-button');
        if (email && container.dataset.emailPlaceholder && email.placeholder !== container.dataset.emailPlaceholder) {
          email.placeholder = container.dataset.emailPlaceholder;
        }
        // The button can arrive before the email field. Replacing its text on
        // every observed mutation would keep triggering this observer forever.
        if (button && container.dataset.buttonLabel && button.textContent !== container.dataset.buttonLabel) {
          button.textContent = container.dataset.buttonLabel;
        }
        return Boolean(email && button);
      };

      if (!customizeForm() && container.dataset.klaviyoObserved !== 'true') {
        container.dataset.klaviyoObserved = 'true';
        const observer = new MutationObserver(() => {
          if (customizeForm()) observer.disconnect();
        });
        observer.observe(container, { childList: true, subtree: true });
      }

      const existingScript = document.querySelector(`script[data-klaviyo-company-id="${companyId}"], script[src*="static.klaviyo.com/onsite/js"][src*="company_id=${companyId}"]`);
      if (existingScript) return;

      const script = document.createElement('script');
      script.async = true;
      script.dataset.klaviyoCompanyId = companyId;
      script.src = `https://static.klaviyo.com/onsite/js/${encodeURIComponent(companyId)}/klaviyo.js?company_id=${encodeURIComponent(companyId)}`;
      document.head.appendChild(script);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeKlaviyoForms(), { once: true });
  else initializeKlaviyoForms();
  document.addEventListener('shopify:section:load', (event) => initializeKlaviyoForms(event.target));
})();
